import React from "react";
import { PhoneMissed } from "lucide-react";
import { PAIN_POINTS, IMAGES } from "../mock";
import { useReveal } from "../hooks/useReveal";

export default function Problem() {
  const r = useReveal();
  return (
    <section id="problem" className="bg-ls-alt py-20 md:py-28">
      <div ref={r.ref} className={`max-w-5xl mx-auto px-5 md:px-8 ${r.className}`}>
        <p className="ls-eyebrow mb-4">The honest version</p>
        <h2 className="font-display text-white text-[10vw] sm:text-5xl md:text-6xl max-w-4xl">
          You're losing money every time you miss a call.
        </h2>

        {/* Phone image first */}
        <div className="mt-10 max-w-md mx-auto">
          <div className="hero-frame rounded-3xl overflow-hidden bg-black">
            <img
              src={IMAGES.missedCall}
              alt="A missed call is a missed job"
              className="w-full aspect-[4/5] object-cover"
            />
          </div>
        </div>

        {/* "See if any of these sound like you" — now under the phone image */}
        <div className="mt-12 max-w-2xl">
          <p className="text-lg text-[#c7bdae] leading-relaxed">
            Every home service business we talk to says the same handful of things. See if any of these sound like you.
          </p>
        </div>

        <div className="mt-8 max-w-3xl space-y-1">
          {PAIN_POINTS.map((p) => (
            <div
              key={p.n}
              className="flex gap-5 items-center py-4 border-b"
              style={{ borderColor: "var(--ls-border)" }}
            >
              <span className="big-index text-2xl opacity-70 shrink-0 w-8">{p.n}</span>
              <p className="text-[#e9e2d6] text-lg font-medium leading-snug">&ldquo;{p.text}&rdquo;</p>
            </div>
          ))}
        </div>

        <div className="mt-10 inline-flex items-center gap-3 text-[#a99f92]">
          <PhoneMissed className="w-5 h-5 text-orange" />
          <span className="font-cond tracking-wide text-lg">Missed calls are missed money. Let's fix that.</span>
        </div>
      </div>
    </section>
  );
}
